module.exports = __webpack_public_path__ + "img/orange_041.ba3937e9.png";